import { render, staticRenderFns } from "./archiveTab.vue?vue&type=template&id=69d28e40&scoped=true&"
import script from "./archiveTab.vue?vue&type=script&lang=js&"
export * from "./archiveTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d28e40",
  null
  
)

export default component.exports